import { useEffect, useState } from 'react'
import { ALL_ELEMENTS, ELEMENTS, PARAMETER_EVENT, WIDGET_CLASS_ATTRIBUTES } from '../../utils/constants';
import { activeIcon, getAllComments } from '../../utils';

const useContentAdjustment = () => {
    //  STATES  //
    const [zoom, setZoom] = useState(1);
    const [fontsize, setFontsize] = useState(Number(localStorage.getItem("rcp-font-size")) ?? 0);
    const [lineHeight, setLineHeight] = useState(1.5);
    const [letterSpacing, setLetterSpacing] = useState(1);

    let html = document.getElementsByTagName("html")[0];
    let body = document.getElementsByTagName("body")[0];


    useEffect(() => {
        const root = document.querySelector(":root");

        //  CONTENT SCALLING  //
        zoom === 1 ? '' : body.style.zoom = `${zoom}`;

        //  LINE HEIGHT  //
        lineHeight === 1.5 ?
            root.style.removeProperty("--line-height") :
            root.style.setProperty("--line-height", lineHeight);

        //  LETTER SPACING  //
        letterSpacing === 1 ?
            root.style.removeProperty("--letter-spacing") :
            root.style.setProperty("--letter-spacing", letterSpacing + "px");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zoom, lineHeight, letterSpacing])


    //  TEXT MAGNIFIER  //
    function textMagnifier(CheckMark) {
        let isBoxId = document.querySelector("#textMagnifier");

        //  ADD TEXT MAGNIFIER TOOLTIP CONTAINER  //
        let getTextMagnifier = document.querySelector('.text-magnifier-container');
        if (!getTextMagnifier) {
            const newDiv = document.createElement("div");
            newDiv.className = "text-magnifier-container";
            body.appendChild(newDiv);
        }

        const textMagnifiEreventListnerFunc = (e) => {
            const element = e.target;
            const tooltipAttribite = element.getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_TOOLTIP);
            const value = element.nodeName === ELEMENTS.IMG ? element.getAttribute("alt") : tooltipAttribite ? element?.innerText :"";

            const mousemoveDiv = document.querySelector(".text-magnifier-container");
            if (!mousemoveDiv) return;


            mousemoveDiv.innerHTML = value || "";

            if (document.body.contains(mousemoveDiv))
                mousemoveDiv.style.left = e.pageX + 20 + "px";
            if (document.body.contains(mousemoveDiv))
                mousemoveDiv.style.top = e.pageY - 20 + "px";
        };

        const applyTextMagnifier = () => {
            html.classList.add("textMagnifier");
            isBoxId.classList.add('rcpEnableFeature');

            let getCommentsFunc = getAllComments(document.body);
            const elements = document.querySelectorAll(ALL_ELEMENTS);
            for (let i = 0; i < elements.length; i++) {
                for (let j = 0; j < elements[i].childNodes.length; j++) {
                    if (elements[i].childNodes[j]?.nodeValue && elements[i].childNodes[j]?.nodeValue.trim()) {
                        const attribute = elements[i].getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_TOOLTIP);
                        if (!attribute && !getCommentsFunc.includes(elements[i].childNodes[j]?.nodeValue)) {
                            elements[i].setAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_TOOLTIP, true);
                        }
                    }
                }
            }

            body.addEventListener("mouseover", textMagnifiEreventListnerFunc);
            localStorage.setItem("rcp-text-magnifier", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
        const removeTextMagnifier = () => {
            html.classList.remove("textMagnifier");
            isBoxId.classList.remove('rcpEnableFeature');
            const elements = document.querySelectorAll(ALL_ELEMENTS);
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_TOOLTIP)) {
                    elements[i].removeAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_TOOLTIP);
                }
            }
            body.removeEventListener("mouseover", textMagnifiEreventListnerFunc);
            localStorage.removeItem("rcp-text-magnifier");
            activeIcon(PARAMETER_EVENT.NONE);
            body.removeChild(getTextMagnifier);
        }

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("textMagnifier") && isBoxId.classList.contains('rcpEnableFeature')) ? removeTextMagnifier() : applyTextMagnifier();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyTextMagnifier();
        }
    }

    //  READABLE FONT  //
    const readableFont = (CheckMark) => {
        const isBoxId = document.querySelector("#readableFont");

        const applyReadableFont = () => {
            html.classList.add("rcp-font-bold");
            isBoxId?.classList.add('rcpEnableFeature');
            localStorage.setItem("rcp-readable-font", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const removeReadableFont = () => {
            html.classList.remove("rcp-font-bold");
            isBoxId?.classList.remove('rcpEnableFeature');
            localStorage.removeItem("rcp-readable-font");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcp-font-bold") && isBoxId?.classList.contains('rcpEnableFeature')) ? removeReadableFont() : applyReadableFont();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyReadableFont();
        }
    };

    //  HIGH LIGHT TILES  //
    function highLightTile(CheckMark) {
        const isBoxId = document.querySelector("#highLightTiles");

        const applyHighLight = () => {
            html.classList.add("rcp-highlight-tile");
            isBoxId?.classList.add('rcpEnableFeature');
            localStorage.setItem("rcp-highlight-tile", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const removeHighLight = () => {
            html.classList.remove("rcp-highlight-tile");
            isBoxId?.classList.remove('rcpEnableFeature');
            localStorage.removeItem("rcp-highlight-tile");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcp-highlight-tile") && isBoxId?.classList.contains('rcpEnableFeature')) ? removeHighLight() : applyHighLight();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyHighLight();
        }
    }

    //  HIGHT LIGHT LINKS  //
    function HighlightLinks(CheckMark) {
        const isBoxId = document.querySelector("#highLightLinks");

        const applyHighlight = () => {
            html.classList.add("rcp-highlight-links");
            isBoxId?.classList.add('rcpEnableFeature');
            localStorage.setItem("rcp-highlight-links", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const removeHighlight = () => {
            html.classList.remove("rcp-highlight-links");
            isBoxId?.classList.remove('rcpEnableFeature');
            localStorage.removeItem("rcp-highlight-links");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcp-highlight-links") && isBoxId?.classList.contains('rcpEnableFeature')) ? removeHighlight() : applyHighlight();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyHighlight();
        }
    }

    //  TEXT ALIGN CENTER  //
    function textAlignCenter(CheckMark) {
        const isBoxId = document.querySelector("#textAlignCenter");

        const applyTextAlignCenter = () => {
            textAlignRight(PARAMETER_EVENT.REMOVE);
            textAlignLeft(PARAMETER_EVENT.REMOVE);
            html.classList.add("rcp-text-align-center");
            isBoxId?.classList.add('rcpEnableFeature');
            localStorage.setItem("rcp-text-align-center", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const removeTextAlignCenter = () => {
            html.classList.remove("rcp-text-align-center");
            isBoxId?.classList.remove('rcpEnableFeature');
            localStorage.removeItem("rcp-text-align-center");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcp-text-align-center") && isBoxId?.classList.contains('rcpEnableFeature')) ? removeTextAlignCenter() : applyTextAlignCenter();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyTextAlignCenter();
        } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
            removeTextAlignCenter();
        }
    }

    //  TEXT ALIGN LEFT  //
    function textAlignLeft(CheckMark) {
        const isBoxId = document.querySelector("#textAlignLeft");

        const applyTextAlignLeft = () => {
            textAlignCenter(PARAMETER_EVENT.REMOVE);
            textAlignRight(PARAMETER_EVENT.REMOVE);
            html.classList.add("rcp-textalign-left");
            isBoxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-textalign-left", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const removeTextAlignLeft = () => {
            html.classList.remove("rcp-textalign-left");
            isBoxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-textalign-left");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcp-textalign-left") && isBoxId.classList.contains("rcpEnableFeature")) ? removeTextAlignLeft() : applyTextAlignLeft();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyTextAlignLeft();
        } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
            removeTextAlignLeft();
        }
    }

    //  TEXT ALIGN RIGHT  //
    function textAlignRight(CheckMark) {
        let isBoxId = document.querySelector("#textAlignRight");

        const applyTextAlignRight = () => {
            textAlignCenter(PARAMETER_EVENT.REMOVE);
            textAlignLeft(PARAMETER_EVENT.REMOVE);
            html.classList.add("rcp-textalign-right");
            isBoxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-textalign-right", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const removeTextAlignRight = () => {
            html.classList.remove("rcp-textalign-right");
            isBoxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-textalign-right");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcp-textalign-right") && isBoxId.classList.contains('rcpEnableFeature')) ? removeTextAlignRight() : applyTextAlignRight();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyTextAlignRight()
        } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
            removeTextAlignRight()
        }
    }

    //  CONTENT SCALLING  //
    function contentScaling(CheckMark) {
        let newZoom = zoom;

        if (CheckMark === PARAMETER_EVENT.PLUS) {
            newZoom += 0.01;
        } else if (CheckMark === PARAMETER_EVENT.MINUS) {
            newZoom -= 0.01;
        }

        setZoom(newZoom);

        if (newZoom === 1) {
            localStorage.removeItem("rcp-content-scaling");
            activeIcon(PARAMETER_EVENT.NONE);
        } else {
            localStorage.setItem("rcp-content-scaling", newZoom);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
    }

    //  FONT SIZE  //
    function handleFontSize(CheckMark) {
        let ele = document.querySelectorAll(ALL_ELEMENTS);

        const updateFontSize = (value) => {
            let isIncreamentVar = value;
            setFontsize(isIncreamentVar);
            if (value === 0) {
                localStorage.removeItem("rcp-font-size");
                activeIcon(PARAMETER_EVENT.NONE);
            } else {
                localStorage.setItem("rcp-font-size", isIncreamentVar);
                activeIcon(PARAMETER_EVENT.BLOCK);
            }
            for (let i = 0; i < ele.length; i++) {
                let getAttri = ele[i].getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_FONTSIZE);
                let removePX = getAttri !== null ? Number(getAttri.replace(/[^0-9.]/g, "")) : null;
                if (removePX !== null) {
                    let newFontSize = removePX + isIncreamentVar;
                    let getOldStyle = ele[i].getAttribute("style");
                    let newStyle;
                    if (getOldStyle) {
                        if (getOldStyle.includes("font-size")) {
                            newStyle = getOldStyle.replace(/font-size:\s*\d+(\.\d+)?px\s*!/g, `font-size:${newFontSize}px !`);
                        } else {
                            newStyle = `${getOldStyle} font-size:${newFontSize}px !important`
                        }
                    } else {
                        newStyle = `font-size:${newFontSize}px !important`
                    }
                    ele[i].setAttribute("style", newStyle);
                }
            }
        }

        if (CheckMark === PARAMETER_EVENT.PLUS) {
            updateFontSize(fontsize + 1);
        } else if (CheckMark === PARAMETER_EVENT.MINUS) {
            updateFontSize(fontsize - 1);
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            let sizeFont = parseFloat(localStorage.getItem("rcp-font-size"));
            let onLoadValue = parseInt(sizeFont);
            updateFontSize(onLoadValue);
        }
    }

    //  LINE HEIGHT  //
    function handleLineHeight(CheckMark) {
        let newLineHeight = lineHeight;

        body.classList.add("rcpLineHeight");

        if (CheckMark === PARAMETER_EVENT.PLUS) {
            newLineHeight += 0.1;
        } else if (CheckMark === PARAMETER_EVENT.MINUS) {
            newLineHeight -= 0.1;
        }

        setLineHeight(newLineHeight);

        if (newLineHeight === 1.5) {
            body.classList.remove("rcpLineHeight");
            localStorage.removeItem("rcp-line-height");
            activeIcon(PARAMETER_EVENT.NONE);
        } else {
            localStorage.setItem("rcp-line-height", newLineHeight);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
    }

    //  LETTER SPACING  //
    function handleLetterSpacing(CheckMark) {
        let newLetterSpacing = letterSpacing;

        body.classList.add("rcpLetterSpacing");

        if (CheckMark === PARAMETER_EVENT.PLUS) {
            newLetterSpacing += 1;
        } else if (CheckMark === PARAMETER_EVENT.MINUS) {
            newLetterSpacing -= 1;
        }

        setLetterSpacing(newLetterSpacing);

        if (newLetterSpacing === 1) {
            localStorage.removeItem("rcp-letter-spacing");
            body.classList.remove("rcpLetterSpacing");
            activeIcon(PARAMETER_EVENT.NONE);
        } else {
            localStorage.setItem("rcp-letter-spacing", newLetterSpacing);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
    }

    return { readableFont, highLightTile, HighlightLinks, textAlignCenter, textAlignLeft, textAlignRight, textMagnifier, zoom, contentScaling, setZoom, fontsize, setFontsize, handleFontSize, lineHeight, setLineHeight, handleLineHeight, handleLetterSpacing, letterSpacing, setLetterSpacing }
}

export default useContentAdjustment